"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Smooth scrolls to a specific point
 */

function easeInOut(currTime, start, change, duration) {
  var currentTime = currTime;
  currentTime /= duration / 2;
  if (currentTime < 1) {
    // eslint-disable-next-line
    return change / 2 * currentTime * currentTime + start;
  }
  currentTime -= 1;
  // eslint-disable-next-line
  return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
}

function smoothScrollTo(to, duration) {
  var start = window.pageYOffset;
  var change = to - start;
  var increment = 20;

  var animateScroll = function animateScroll(elTime) {
    var elapsedTime = elTime;
    elapsedTime += increment;
    var position = easeInOut(elapsedTime, start, change, duration);
    window.scrollTo(0, position);
    if (elapsedTime < duration) {
      setTimeout(function () {
        animateScroll(elapsedTime);
      }, increment);
    }
  };

  animateScroll(0);
}

exports.default = smoothScrollTo;